module.exports = __webpack_public_path__ + "static/media/trash.0da28ad1.svg";